
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";


function App() {
  return (
    <Router>
      <Routes>
        {/* Homepage route */}
        <Route path="/" element={<Homepage />} />
        
        {/* /test route with backend message */}
        
      </Routes>
    </Router>
  );
}

export default App;
